import styles from "../CreatorsPage.module.scss";
import { SMark } from "./icons";

export const Nav = () => (
	<header className={styles.nav}>
		<div className={styles.wrap}>
			<a className={styles.brand} href="#top">
				<SMark />
				<span className={styles.wordmark}>stippl</span>
				<small>Creators</small>
			</a>
			<nav className={styles.navLinks} aria-label="Sections">
				<a href="#earn">Earn</a>
				<a href="#make">What you create</a>
				<a href="#how">How it works</a>
				<a href="#faq">FAQ</a>
			</nav>
			<a className={`${styles.btn} ${styles.btnGreen}`} href="#apply">
				Apply
			</a>
		</div>
	</header>
);

export const Footer = () => (
	<footer>
		<div className={styles.wrap}>
			<span>
				© 2026 <span className={styles.wordmark}>stippl</span> · Plan, travel, relive
			</span>
			<span>
				<a href="https://www.stippl.io/privacy">Privacy</a> · <a href="https://www.stippl.io">stippl.io</a>
			</span>
		</div>
	</footer>
);
